'use client';

import { c as _c } from "react/compiler-runtime";
import { AlertCircle, Check, CheckCheck, Clock } from 'lucide-react';
import type { MensagemStatus } from '@/shared/types/mensagemStatus';
interface OutboundStatusIconProps {
  status: MensagemStatus;
  onLight?: boolean;
  size?: number;
  title?: string;
}

/**
 * Vocabulário visual único de status de mensagem enviada: relógio = enviando, ✓ cinza = enviada,
 * ✓✓ cinza = entregue, ✓✓ azul = lida, alerta = falha. O `aria-label` carrega o mesmo rótulo,
 * porque a diferença entre "entregue" e "lida" é só a cor do ícone.
 *
 * Promovido de `features/chatAtendimento` quando o Certificado de Acessos virou o segundo
 * consumidor: lá o ✓✓ azul afirma ciência dentro de uma peça de prova, então os dois pontos do
 * produto que desenham esse ícone precisam derivar do MESMO mapa — duas cópias divergem em
 * silêncio e o certificado passa a afirmar leitura por conta própria.
 */
export const OutboundStatusIcon = t0 => {
  const $ = _c(12);
  const {
    status,
    onLight: t1,
    size: t2,
    title
  } = t0;
  const onLight = t1 === undefined ? false : t1;
  const size = t2 === undefined ? 13 : t2;
  const dim = onLight ? "shrink-0 text-neutral-500" : "shrink-0 text-white/70";
  const seen = onLight ? "shrink-0 text-information-color-support-info-600" : "shrink-0 text-information-color-support-info-300";
  let t3;
  if ($[0] !== dim || $[1] !== seen || $[2] !== size || $[3] !== status) {
    t3 = status === "PENDING" ? <Clock size={size} className={dim} aria-hidden={true} /> : status === "SENT" ? <Check size={size} className={dim} aria-hidden={true} /> : status === "DELIVERED" ? <CheckCheck size={size} className={dim} aria-hidden={true} /> : status === "SEEN" ? <CheckCheck size={size} className={seen} aria-hidden={true} /> : <AlertCircle size={size} className="text-error-500 shrink-0" aria-hidden={true} />;
    $[0] = dim;
    $[1] = seen;
    $[2] = size;
    $[3] = status;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const icon = t3;
  const label = status === "PENDING" ? "Enviando" : status === "SENT" ? "Enviada" : status === "DELIVERED" ? "Entregue" : status === "SEEN" ? "Lida" : "Falha no envio";
  const t4 = title ?? label;
  let t5;
  if ($[5] !== label || $[6] !== title) {
    t5 = title ? `${label}. ${title.replace(/\n/g, "; ")}` : label;
    $[5] = label;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== icon || $[9] !== t4 || $[10] !== t5) {
    t6 = <span className="inline-flex shrink-0" title={t4} aria-label={t5}>{icon}</span>;
    $[8] = icon;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};